import { render, staticRenderFns } from "./BlockText.vue?vue&type=template&id=7ef7334c&scoped=true"
import script from "./BlockText.vue?vue&type=script&lang=js"
export * from "./BlockText.vue?vue&type=script&lang=js"
import style0 from "./BlockText.vue?vue&type=style&index=0&id=7ef7334c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef7334c",
  null
  
)

export default component.exports